/* eslint-disable i18next/no-literal-string -- ignore*/
import {
  useGetUserLazyQuery,
  type UserFragment,
} from '@/affiliate-dashboard/graphql';
import { Button } from '@/components/base/button';
import { Input } from '@/components/base/form/input';
import Section from '@/components/base/section';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/base/tooltip';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { faEarth } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from '@tanstack/react-router';
import { format } from 'date-fns';
import { useCallback, useState } from 'react';
import ReactCountryFlag from 'react-country-flag';

export function Promoters(): JSX.Element {
  const [getUser] = useGetUserLazyQuery();
  const [user, setUser] = useState<UserFragment | null | undefined>(null);

  const debouncedOnChange = useCallback((searchValue: string) => {
    const timeout = setTimeout(async () => {
      const data = await getUser({
        variables: { searchString: searchValue ?? '' },
      });
      setUser(data.data?.user);
    }, 1000);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Section variant="secondary">
      <div className="flex w-full flex-col gap-5 divide-y divide-default-gray-700">
        <fieldset className="w-fit">
          <div className="flex items-center gap-1">
            <span>User Search Value</span>

            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger>
                  <div className="flex items-center gap-2 p-2 text-default-gray-500">
                    <FontAwesomeIcon
                      className="h-4 w-4"
                      icon={faCircleExclamation}
                    />
                  </div>
                </TooltipTrigger>
                <TooltipContent>
                  email/dicsount code/order number
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          </div>
          <Input
            onChange={(e) => {
              debouncedOnChange(e.target.value);
            }}
            inputSize="sm"
            variant="secondary"
          />
        </fieldset>

        {user && (
          <div className="flex flex-col pt-5">
            <div className="flex items-center gap-2">
              <span>
                {user?.firstName} {user?.lastName}
              </span>
              <Link to={`/dashboard/admin/promoter-detail/${user?.email}`}>
                <Button variant="outlined" className="px-2 py-1 text-xs">
                  Detail
                </Button>
              </Link>
            </div>
            <span className="text-default-gray-500">{user?.email}</span>
            <span className="text-default-gray-500">{user?.userNumber}</span>
            <div className="flex items-center gap-2">
              {user?.countryCode ? (
                <ReactCountryFlag
                  countryCode={user?.countryCode}
                  style={{
                    height: '1.1rem',
                    width: '1.1rem',
                    borderRadius: '100%',
                    objectFit: 'cover',
                  }}
                  svg
                />
              ) : (
                <FontAwesomeIcon className="h-4 w-4" icon={faEarth} />
              )}
              <span className="text-default-gray-500">{user?.countryName}</span>
            </div>
            <span className="text-default-gray-500">
              Joined on{' '}
              <span>{format(user?.createdAt ?? '', 'dd MMM yyyy')}</span>
            </span>
            <span className="text-default-gray-500">{user?.phone}</span>
          </div>
        )}
      </div>
    </Section>
  );
}
